import {Component} from '@angular/core';
import {AuthenticationService} from './services/authentication.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isAuthenticated$: Observable<boolean> = this.authenticationService.isAuthenticatedEvent;

  constructor(private authenticationService: AuthenticationService) {

  }
}
